import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const isLoadingSelector = (statusKey) => (state) => state.settlements[statusKey] === REDUX_ASYNC_STATUSES.LOADING;
const isFailedSelector = (statusKey) => (state) => state.settlements[statusKey] === REDUX_ASYNC_STATUSES.FAILED;

export const selectSettlements = (state) => state.settlements?.settlements;

// 'invoice' / 'quotation' or undefined while the settlements of the claim are not loaded yet
export const selectSettlementTypeById = (settlementId) => (state) =>
  selectSettlements(state)?.find((settlement) => settlement.id === settlementId)?.type;

export const selectCreateSettlementLoading = isLoadingSelector('createSettlementStatus');
export const selectUpdateSettlementLoading = isLoadingSelector('updateSettlementStatus');

export const selectCutbackReasons = (state) => state.settlements?.cutbackReasons;

export const selectExportSettlementsLoading = isLoadingSelector('exportSettlementsStatus');
export const selectExportSettlementsFailed = isFailedSelector('exportSettlementsStatus');
